// import moment from "moment"
export default function formattingPriceData(obj, value) {
  let baseInfo = {}
  if (obj.baseInfo && value) {
    baseInfo = {
      policyNo: '', // 商业险保单号
      proposalNo: '', // 商业险投保单号
      policyNoCI: '', // 交强险保单号
      proposalNoCI: '', // 交强险投保单号
      underWriteFlag: '', // 商业险核保状态代码
      underWriteFlagCI: '', // 交强险核保状态代码
      underWriteMessageCI: '', // 交强险核保信息
      underWriteMessage: '', // 商业险核保信息
      CIApplicationStatus: '', // 交强险保单状态
      applicationStatus: '', // 商业险保单状态
      startDate: obj.baseInfo.startDate, // 商业险起保时间
      startHour: obj.baseInfo.startHour, // 商业险起保小时
      endDate: obj.baseInfo.endDate, // 商业险终保时间
      endHour: obj.baseInfo.endHour, // 商业险终保小时
      startDateCI: obj.baseInfo.startDateCI, // 交强险起保时间
      startHourCI: obj.baseInfo.startHourCI, // 交强险起保小时
      endDateCI: obj.baseInfo.endDateCI, // 交强险终保时间
      endHourCI: obj.baseInfo.endHourCI, // 交强险终保小时
      startMinuteCI: obj.baseInfo.startMinuteCI, // 交强险起保分钟
      endMinuteCI: obj.baseInfo.endMinuteCI, // 交强险终保分钟
      startMinute: obj.baseInfo.startMinute, // 商业险起保分钟
      endMinute: obj.baseInfo.endMinute, // 商业险终保分钟
      inputDate: '', // 录单时间
      PNPDate: '', // 保单生成时间
      calculateFlag: obj.baseInfo.calculateFlag, // 是否关联单标识
      isInstantFlag: '', // 是否即时生效
      autoTransRenewFlag: '', // 支付方式
      sumPremium: '', // 商业险总保费
      sumPremiumCI: '', // 交强险总保费
      policyType: '', // 商业险保单类型
      invoiceType: '', // 商业险发票类型
      policyTypeCI: '', // 交强险保单类型
      invoiceTypeCI: '', // 交强险发票类型
      applicationType: 'P',
      arbitBoardName: obj.baseInfo.arbitBoardName,
      argueSolution: obj.baseInfo.argueSolution,
      demandNo: value.demandNo,
      demandNoCI: value.demandNoCI,
      answer: value.answer,
      answerCI: value.answerCI,
      cityCode: obj.baseInfo.cityCode,
      provinceCode: obj.baseInfo.provinceCode
    }
  } else if (obj.baseInfo) {
    baseInfo = {
      policyNo: '', // 商业险保单号
      proposalNo: '', // 商业险投保单号
      policyNoCI: '', // 交强险保单号
      proposalNoCI: '', // 交强险投保单号
      underWriteFlag: '', // 商业险核保状态代码
      underWriteFlagCI: '', // 交强险核保状态代码
      underWriteMessageCI: '', // 交强险核保信息
      underWriteMessage: '', // 商业险核保信息
      CIApplicationStatus: '', // 交强险保单状态
      applicationStatus: '', // 商业险保单状态
      startDate: obj.baseInfo.startDate, // 商业险起保时间
      startHour: obj.baseInfo.startHour, // 商业险起保小时
      endDate: obj.baseInfo.endDate, // 商业险终保时间
      endHour: obj.baseInfo.endHour, // 商业险终保小时
      startDateCI: obj.baseInfo.startDateCI, // 交强险起保时间
      startHourCI: obj.baseInfo.startHourCI, // 交强险起保小时
      endDateCI: obj.baseInfo.endDateCI, // 交强险终保时间
      endHourCI: obj.baseInfo.endHourCI, // 交强险终保小时
      startMinuteCI: obj.baseInfo.startMinuteCI, // 交强险起保分钟
      endMinuteCI: obj.baseInfo.endMinuteCI, // 交强险终保分钟
      startMinute: obj.baseInfo.startMinute, // 商业险起保分钟
      endMinute: obj.baseInfo.endMinute, // 商业险终保分钟
      inputDate: '', // 录单时间
      PNPDate: '', // 保单生成时间
      calculateFlag: obj.baseInfo.calculateFlag, // 是否关联单标识
      isInstantFlag: '', // 是否即时生效
      autoTransRenewFlag: '', // 支付方式
      sumPremium: '', // 商业险总保费
      sumPremiumCI: '', // 交强险总保费
      policyType: '', // 商业险保单类型
      invoiceType: '', // 商业险发票类型
      policyTypeCI: '', // 交强险保单类型
      invoiceTypeCI: '', // 交强险发票类型
      applicationType: 'P',
      arbitBoardName: obj.baseInfo.arbitBoardName,
      argueSolution: obj.baseInfo.argueSolution,
      cityCode: obj.baseInfo.cityCode,
      provinceCode: obj.baseInfo.provinceCode
    }
  }
  let carOwnerInfo = {}
  if (obj.carOwnerInfo) {
    carOwnerInfo = obj.carOwnerInfo
  }
  let carPolicySubInfoList
  if (obj.carPolicySubInfoList) {
    carPolicySubInfoList = obj.carPolicySubInfoList
  }
  let attachRiskList
  if (obj.attachRiskList) {
    attachRiskList = obj.attachRiskList
  }
  const insuredList = []
  if (obj.applicantIn && obj.recognizeeIn) {
    insuredList.push(obj.applicantIn)
    insuredList.push(obj.recognizeeIn)
  }
  // let insuredList = [{
  //   birthday: '', // 出生日期
  //   email: '', // E-mail
  //   identifyNumber: '', // 证件号码
  //   identifyType: '', // 证件类型
  //   insuredFlag: '', // 关系人标志
  //   insuredName: '', // 客户中文名称
  //   insuredType: '', // 客户类型
  //   mobile: '', // 手机
  //   validDate: '' // 证件有效期
  // }]
  const deliveryInfo = {
    receivePhone: '', // 收件人电话
    receiver: '', // 收件人姓名
    receiverMail: '', // 电子邮箱
    receiverAddress: '' // 收件地址
  }
  const engageList = [{
    clauseCode: '', // 特约代码
    clauseName: '', // 特约名称
    clauses: '' // 特约内容
  }]
  const imageInfoList = [{
    fileType: '', // 上传清单类型（1验车照片;2车辆证件;3客户证件;4车辆购置证明;5过户证明;6退保证明;7单证;8申请书;9其他;
    operateTime: '', // 上传时间
    operatorName: '', // 上传人
    fileName: '' // 影像图片
  }]
  const deletedFlag = ''
  let orderId = ''
  if (obj.orderId) {
    orderId = obj.orderId
  }
  let orderNo = ''
  let orderOrigin = ''
  let productName = ''
  if (obj.productName) {
    productName = obj.productName
  }
  if (obj.orderNo) {
    orderNo = obj.orderNo
  }
  if (obj.orderOrigin) {
    orderOrigin = obj.orderOrigin
  }

  // 险别信息
  const itemKindList = []
  if (obj.alter) {
    obj.insurance.forEach((item, index) => {
      if (item.values) {
        const objs = {
          amount: item.amount.code || item.amount || '',
          kindCode: item.kindCode,
          kindName: item.kindName,
          premium: item.premium,
          calculateFlag: item.calculateFlag,
          riskCode: item.riskCode,
          seatCount: item.seatCount, // 投保座位数
          unitAmount: item.unitAmount ? (item.unitAmount.code || '') : '', // 每座保额/日赔偿金
          value: item.value ? (item.value.code || item.value || '') : '', // 可选免赔额
          rate: item.rate, // 费率
          serviceTimes: item.serviceTimes ? (item.serviceTimes.code || item.serviceTimes || '') : '', // 服务次数
          deductibleRate: '' // 免赔率
        }
        if (item.accessoryRisk) {
          item.accessoryRisk.forEach((kind) => {
            if (kind.values) {
              const param = {
                kindCode: kind.kindCode,
                kindName: kind.kindName,
                premium: kind.premium,
                calculateFlag: kind.calculateFlag,
                riskCode: kind.riskCode,
                seatCount: kind.seatCount, // 投保座位数
                unitAmount: '', // 每座保额/日赔偿金
                value: kind.value ? (kind.value.code || kind.value || '') : '', // 可选免赔额
                rate: kind.rate, // 费率
                amount: kind.amount.code || kind.amount || '',
                deductibleRate: kind.deductibleRate ? kind.deductibleRate.code : '', // 免赔率
                serviceTimes: '' // 服务次数
              }
              itemKindList.push(param)
            }
          })
        }
        itemKindList.push(objs)
      }
    })
  }
  if (obj.JQstatus) {
    itemKindList.push(obj.JQinsurance)
  }
  itemKindList.forEach(item => {
    if (item.kindCode !== 'A') {
      item.value = '0'
    }
    if (item.premium === '报价后可见') {
      item.premium = ''
    }
  })
  // let profitDataList = [{
  //   fieldValue: '', // 费率项取值
  //   profitCode: '', // 费率因子代码
  //   profitName: '', // 费率因子名称
  //   profitRate: '' // 费率因子值
  // }]
  const profitDataList = []
  if (obj.channel && obj.underwriting) {
    if (obj.channel.profitRate !== '' && obj.underwriting.profitRate !== '') {
      profitDataList.push(obj.channel)
      profitDataList.push(obj.underwriting)
    }
  }
  const taxRelifInfo = {}
  if (obj.taxRelifInfo) {
    taxRelifInfo.extendChar2 = obj.taxRelifInfo.extendChar2
    taxRelifInfo.taxComName = obj.taxRelifInfo.taxComName
    taxRelifInfo.taxRelifFlag = obj.taxRelifInfo.hfCode
    taxRelifInfo.paidFreeCertificate = obj.taxRelifInfo.paidFreeCertificate
    taxRelifInfo.taxDocumentDate = obj.taxRelifInfo.taxDocumentDate
    taxRelifInfo.sumPayTax = obj.taxRelifInfo.SumPayTax
    taxRelifInfo.taxPaidAreaCode = obj.taxRelifInfo.taxPaidAreaCode
    taxRelifInfo.taxComCode = obj.taxRelifInfo.taxComCode
    taxRelifInfo.taxRegistryNumber = obj.taxRelifInfo.taxRegistryNumber
  }
  let vehicleInfo = {}
  if (obj.vehicleInfo) {
    vehicleInfo = obj.vehicleInfo
  }
  // 有关驾驶人意外险的部分
  // let carPolicySubInfoList = []
  // if (obj.scheme && obj.scheme.code) {
  //   let data = {
  //     insureGradeNo: obj.scheme.code,
  //     riskName: obj.scheme.text,
  //     quantity: '1',
  //     riskCode: obj.scheme.riskCode,
  //     sumAmount: obj.scheme.sumAmount,
  //     sumPremium: obj.scheme.sumPremium,
  //     commiFee: obj.scheme.commiFee
  //   }
  //   carPolicySubInfoList.push(data)
  // }
  return {
    baseInfo,
    carOwnerInfo,
    insuredList,
    deliveryInfo,
    engageList,
    imageInfoList,
    deletedFlag,
    itemKindList,
    profitDataList,
    taxRelifInfo,
    vehicleInfo,
    orderId,
    orderNo,
    orderOrigin,
    productName,
    carPolicySubInfoList,
    attachRiskList
  }
}



// WEBPACK FOOTER //
// ./src/utils/formattingPriceData.js